




























































































































































































































import { Component, Vue } from "vue-property-decorator";
import { dataList, boxList } from "@/components/listData";
import tabs from "./components/tabs.vue";
import { getEngine } from "@/req/homes";
import download from "./components/download.vue";
import reagister from "../../components/reagister.vue";
@Component({
  components: { tabs, download, reagister },
})
export default class Home extends Vue {
  public activeIndex: any = 1;
  public selectModel = {};
  public dataModel = [
    {
      id: 1,
      name: ["996传奇引擎", "多端版"],
      titleUrl: require("@/assets/img/engine/cq-title-icon.png"),
      dec: ["传奇脚本写法 懂传奇就能做", "一键工具转换 支持脚本平移"],
      cateList: [
        {
          icon: require("@/assets/img/engine/cq-tab-icon1.png"),
          name: "正版授权 多端互通",
          text: "正版授权引擎，支持iOS、Android、PC、H5、3D多平台开发，高效、稳定跨平台，数据三端互通。",
        },
        {
          icon: require("@/assets/img/engine/cq-tab-icon2.png"),
          name: "可视化开发 自由定制",
          text: "自由编辑游戏GUI界面、属性、游戏参数，自由定义游戏玩法，游戏任务、活动、地图、怪物等游戏机制等自由创造，轻松创造自己的传奇游戏。",
        },
        {
          icon: require("@/assets/img/engine/cq-tab-icon3.png"),
          name: "多套便捷开发工具支持",
          text: "提供多套工具协助开发者开发，方便开发者资源、脚本、数据库转换，不定时更新工具功能。",
        },
        {
          icon: require("@/assets/img/engine/cq-tab-icon4.png"),
          name: "强大的996M2反外挂系统",
          text: "云端智能反外挂，对抗移动应用暴力破解，在网络层、应用层、系统层提供全面安全防护，安全与兼容性并行，无感知安全防护，不影响游戏玩家体验。",
        },
        {
          icon: require("@/assets/img/engine/cq-tab-icon5.png"),
          name: "兼容其他传奇引擎 一键转换",
          text: "兼容其他传奇引擎，传奇脚本一键转换，助力传奇开发者快速开发。",
        },
        {
          icon: require("@/assets/img/engine/cq-tab-icon6.png"),
          name: "提供数套开区底版 持续更新",
          text: "为传奇开发者学习996传奇引擎提供内容支持，免费提供多套传奇开区底版，版本内容丰富，持续更新。",
        },
      ],
      butImg: require("@/assets/img/engine/tab-pone-item1.png"),
      butImgAct: require("@/assets/img/engine/tab-pone-item1-act.png"),
      downloadInfo: [
        // [
        //   {
        //     text: "下载PC版",
        //     link: "/static/app/热血合击_pc_gm_v3.1.1.zip",
        //     target: "_blank",
        //     size: "游戏：热血合击(75.1MB)",
        //     state: 1,
        //   },
        //   {
        //     text: "下载Android版",
        //     link: "/static/app/热血合击_安卓-64位_3.2.401_1(1.0.0)_05311517.apk",
        //     target: "_blank",
        //     size: "游戏：热血合击(84.9MB)",
        //     state: 1,
        //   },
        // ],
        // [
        //   {
        //     text: "引擎下载",
        //     link: "/static/app/996M2(2022.05.20.0_64位).rar",
        //     target: "_blank",
        //     size: "安装包大小：134.3MB",
        //     state: 1,
        //   },
        //   {
        //     text: "基础包下载",
        //     link: "http://bbs.996m2.com/forum-48-1.html",
        //     target: "_blank",
        //     size: "安装包大小：62.8MB",
        //     state: 2,
        //   },
        // ],
      ],
    },
    {
      id: 2,
      name: ["996传奇引擎", "PC版"],
      titleUrl: require("@/assets/img/engine/pc-title-icon.png"),
      dec: ["永久免费 正版授权"],
      cateList: [
        {
          icon: require("@/assets/img/engine/pc-tab-icon1.png"),
          name: "正版授权 永久免费",
          text: "正版授权引擎，仅支持PC端开发，高效",
        },
        {
          icon: require("@/assets/img/engine/pc-tab-icon2.png"),
          name: "强大的996M2反外挂系统",
          text: "智能反外挂引擎集成，对抗电脑端暴力破解，在网络层、应用层、系统层提供全面安全防护，安全与兼容性并行，无感知安全运行，不影响玩家体验。",
        },
        {
          icon: require("@/assets/img/engine/pc-tab-icon3.png"),
          name: "兼容其他传奇引擎",
          text: "兼容GOM引擎，无缝开区，快捷迅速完成新版本引擎更替。",
        },
        {
          icon: require("@/assets/img/engine/pc-tab-icon4.png"),
          name: "提供数套开区底版 即将上线",
          text: "为传奇开发者学习996传奇引擎，PC版提供内容支持，免费且内容丰富，持续更新",
        },
        {
          icon: require("@/assets/img/engine/pc-tab-icon5.png"),
          name: "996传奇盒子流量支持",
          text: "经审核合格版本上架盒子，助力传奇开发者游戏推广，目前数千款996传奇引擎开发者的产品已上架996传奇盒子。",
        },
        {
          icon: require("@/assets/img/engine/pc-tab-icon6.png"),
          name: "全网CDN加速",
          text: "公共资源支持CDN加速，覆盖范围广，架构灵活、高并发，全程为传奇开发者保驾护航。",
        },
      ],
      butImg: require("@/assets/img/engine/tab-pone-item2.png"),
      butImgAct: require("@/assets/img/engine/tab-pone-item2-act.png"),
      downloadInfo: [
        // [
        //   {
        //     text: "下载PC版",
        //     link: "/static/app/996yq_pc_2021_08_31.zip",
        //     target: "_blank",
        //     size: "游戏：热血合击(88.6MB)",
        //     state: 1,
        //   },
        // ],
        // [
        //   {
        //     text: "引擎下载",
        //     link: "/static/app/996PCM2(2022.05.27).rar",
        //     target: "_blank",
        //     size: "安装包大小：120.32MB",
        //     state: 1,
        //   },
        //   {
        //     text: "基础包下载",
        //     link: "/static/app/Mirserver.rar",
        //     target: "_blank",
        //     size: "安装包大小：61.99MB",
        //     state: 1,
        //   },
        // ],
      ],
    },
    {
      id: 3,
      name: ["996传世引擎", "多端版"],
      titleUrl: require("@/assets/img/engine/cs-title-icon.png"),
      dec: ["正版授权 传世开发者优选引擎"],
      cateList: [
        {
          icon: require("@/assets/img/engine/cs-tab-icon1.png"),
          name: "正版授权 永久免费",
          text: "正版授权引擎，支持iOS、Android、PC多平台开发，高效、稳定跨平台，数据多端互通。",
        },
        {
          icon: require("@/assets/img/engine/cs-tab-icon2.png"),
          name: "996M2智能反外挂系统",
          text: "996M2智能反外挂系统，在网络层、应用层、系统层提供全面安全防护，安全与兼容性并行，无感知安全运行，不影响玩家体验。",
        },
        {
          icon: require("@/assets/img/engine/cs-tab-icon3.png"),
          name: "独家架构 稳定高效",
          text: "由资深开发工程师数年研发，架构灵活、高承载，专为传世版本打造。",
        },
        {
          icon: require("@/assets/img/engine/cs-tab-icon4.png"),
          name: "多套集成工具支持",
          text: "提供多套集成工具支持，方便开发者在资源、脚本、数据库开发处理，集成工具库持续更新。",
        },
        {
          icon: require("@/assets/img/engine/cs-tab-icon5.png"),
          name: "数兆微端 CDN加速",
          text: "移动端、电脑端支持微端，玩家可边玩边下，大大降低开发者推广成本。异地多机房服务集群，覆盖范围广，架构灵活、高并发。",
        },
        {
          icon: require("@/assets/img/engine/cs-tab-icon6.png"),
          name: "996传奇盒子流量支持",
          text: "经审核合格版本上架盒子，助力传世开发者游戏推广，目前数千款996传奇引擎开发者的产品已上架996传奇盒子。",
        },
      ],
      butImg: require("@/assets/img/engine/tab-pone-item3.png"),
      butImgAct: require("@/assets/img/engine/tab-pone-item3-act.png"),
      downloadInfo: [
        // [
        //   {
        //     text: "下载PC版",
        //     link: "https://996box-static.oss-cn-hangzhou.aliyuncs.com/csyq/PCClient/996WolClient.zip",
        //     target: "_blank",
        //     size: "游戏：传世群英(62.8MB)",
        //     state: 3,
        //   },
        //   {
        //     text: "下载Android版",
        //     link: "https://996box-static.oss-cn-hangzhou.aliyuncs.com/csyq/App/996Game_11020955.apk",
        //     target: "_blank",
        //     size: "游戏：传世群英(62.8MB)",
        //     state: 3,
        //   },
        //   {
        //     text: "手游设计版",
        //     link: "https://996box-static.oss-cn-hangzhou.aliyuncs.com/csyq/App/996WooolMLite(20211102).rar",
        //     target: "_blank",
        //     size: "游戏：传世群英(62.8MB)",
        //     state: 4,
        //   },
        // ],
        // [
        //   {
        //     text: "引擎下载",
        //     link: "/static/app/996cs_engine_2022-05-31.rar",
        //     target: "_blank",
        //     size: "安装包大小：7.8MB",
        //     state: 1,
        //   },
        //   {
        //     text: "基础包下载",
        //     link: "http://woool.996m2.com/forum.php?mod=forumdisplay&fid=40",
        //     target: "_blank",
        //     size: "安装包大小：62.8MB",
        //     state: 3,
        //   },
        //   {
        //     text: "MySQL环境",
        //     link: "/static/app/Mysql_cs.zip",
        //     target: "_blank",
        //     size: "安装包大小：64.0MB",
        //     state: 1,
        //   },
        // ],
      ],
    },
  ];
  public dataList = dataList;
  public created() {
    this.getEngineList();
    if (this.$route.query.tab) {
      const selectIndex: any = this.$route.query.tab;
      this.activeIndex = selectIndex;
      this.selectModel = this.dataModel[selectIndex - 1];
    } else {
      this.selectModel = this.dataModel[this.activeIndex - 1];
    }
  }
  public async getEngineList() {
    const res = await getEngine();
    if (res.code == 200) {
      const obj = Object.assign({}, res.data);
      res.data.forEach((its) => {
        if (its.engine_list && its.engine_list.length) {
          its.engine_list.forEach((itd) => {
            itd.list.forEach((element) => {
              element.timer = this.$fn.toViewDates(element.update_time * 1000);
            });
          });
        }
        this.dataModel.forEach((item, index) => {
          if (its.engine_type == item.id) {
            item.downloadInfo = its.engine_list;
          }
        });
      });
    }
  }
  public linkToDevelopers() {
    window.open(
      "http://pure-engine.996yinqing.com/#/login",
      "_blank"
    );
  }
  public registerBtn() {
    const $register = (this as any).$refs.register;
    $register.show();
  }
  public addBoxDownload(item) {
    if (item.state == 1) {
      window.open(
        "https://static.dhsf.xqhuyu.com/offical" + item.link,
        item.target
      );
    }
    if (item.state == 2) {
      window.open(item.link, item.target);
    }
    if (item.state == 3) {
      window.open(item.link, item.target);
    }
    if (item.state == 4) {
      window.open(item.link, item.target);
    }
  }
  public selectCateRow(row) {
    this.activeIndex = row.id;
    this.selectModel = row;
  }
}
